import React from 'react';
import mdImage from '../images/mdimg (2).jpeg';

const Contact = () => {
  return (
    <div className="page">
      <div className="container">
        <div className="page-hero compact-hero">
          <h1 className="hero-kicker">Contact</h1>
        </div>

        <section className="contact-clean-layout">
          <div className="contact-md-card">
            <div className="contact-md-image-wrap">
              <p className="contact-md-label">CHIEF EXECUTIVE OFFICER</p>
              <img src={mdImage} alt="Managing Director" className="contact-md-image" />
            </div>
            <p className="contact-md-name">Avinash Pabbulate</p>
          </div>

          <div className="contact-details-card">
            <h2>Get in touch</h2>

            <div className="contact-detail-row">
              <h3>Contact</h3>
              <p>+91 90590 57001</p>
              <a
                href="https://wa.me/919059057001?text=Hello%20Dynasty%20Agri%20Seeds"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-whatsapp-link"
                aria-label="Chat on WhatsApp"
              >
                <span className="contact-whatsapp-icon" aria-hidden="true">
                  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.11 17.2c-.27-.14-1.58-.78-1.83-.87-.24-.09-.42-.14-.6.14s-.69.87-.84 1.05c-.16.18-.31.2-.58.07-.27-.14-1.12-.41-2.14-1.32-.79-.7-1.32-1.57-1.48-1.83-.16-.27-.02-.41.12-.55.12-.12.27-.31.41-.47.14-.16.18-.27.27-.45.09-.18.04-.34-.02-.47-.07-.14-.6-1.45-.83-1.99-.22-.53-.44-.45-.6-.46h-.51c-.18 0-.47.07-.72.34-.24.27-.94.92-.94 2.24 0 1.32.96 2.6 1.09 2.78.14.18 1.88 2.87 4.55 4.03.64.28 1.13.45 1.52.57.64.2 1.22.17 1.68.1.51-.08 1.58-.65 1.8-1.28.22-.63.22-1.16.16-1.28-.07-.11-.25-.18-.51-.31z" fill="currentColor" />
                    <path d="M27.12 4.88A15.92 15.92 0 0 0 16.02.01C7.2.01.02 7.18.02 16c0 2.82.74 5.58 2.15 8.01L0 32l8.2-2.13a15.94 15.94 0 0 0 7.81 2.03h.01c8.82 0 16-7.17 16-15.99 0-4.27-1.66-8.29-4.9-11.03zm-11.1 24.3h-.01a13.3 13.3 0 0 1-6.77-1.85l-.49-.29-4.86 1.26 1.3-4.73-.32-.49a13.27 13.27 0 0 1-2.06-7.07c0-7.34 5.97-13.31 13.32-13.31 3.55 0 6.89 1.38 9.4 3.9a13.2 13.2 0 0 1 3.9 9.41c0 7.34-5.98 13.31-13.41 13.31z" fill="currentColor" />
                  </svg>
                </span>
                <span>WhatsApp</span>
              </a>
            </div>

            <div className="contact-detail-row">
              <h3>Email</h3>
              <p>
                dynastyagriseeds2024@gmail.com
              </p>
            </div>

            <div className="contact-detail-row">
              <h3>Address</h3>
              <p>
                M/s DYNASTY AGRI SEEDS PVT. LTD.,Shop No. 1& 2, 154/265B, Palanagogahalli,
Kodigehalli Post, Kasaba Hobli, Doddaballapur Taluk,
Bengaluru Rural Dist - 561203, Cell: 90590 57001 <strong>Email:</strong> dynastyagriseeds2024@gmail.com <strong>Website:</strong> www. dynastyagriseeds.com
              </p>
            </div>

            <div className="contact-map-wrap">
              <iframe
                title="Dynasty Agri Seeds location"
                src="https://maps.google.com/maps?q=17.3247818,78.604709&t=&z=17&ie=UTF8&iwloc=&output=embed"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Contact;
